import QR from "../../assets/App Markets/QR.png";
import RuStore from "../../assets/App Markets/RuStore.js";
import GooglePlay from "../../assets/App Markets/GooglePlay.js";
import AppStore from "../../assets/App Markets/AppStore.js";
import Login from "../../assets/Screens/Login.png";
import Chat from "../../assets/Screens/Chat.png";
import Calendar from "../../assets/Screens/CalendarMock.png";

export default function Apps() {
  return (
    <section
      id="apps"
      className="w-full px-[20px] md:px-[24px] pt-[12px] md:pt-[80px] md:pb-[60px]"
    >
      <div className="mx-auto overflow-clip max-w-[1200px] w-full md:min-h-[510px] relative flex flex-col md:justify-between bg-[#F4F1FF] rounded-[25px]">
        <div className="z-10 max-w-[250px] md:max-w-[423px] mx-auto md:mx-0 md:ml-[80px] mt-[36px] md:mt-[80px] flex flex-col gap-[8px] md:gap-[15px] text-center md:text-left">
          <h2 className="!text-[24px] md:!text-[30px] leading-[36px]">
            Скачайте приложение
          </h2>
          <p className="subtitle !text-[20px] leading-[24px]">
            Умные диалоги, настоящие эмоции, живое общение. Приложение помогает
            находить баланс и вдохновение через разговор с ИИ. Это личный
            собеседник, наставник и друг в одном лице.
          </p>
        </div>

        <div className="z-10 md:ml-[50px] md:mb-[50px] p-[25px] flex gap-0 md:gap-[30px] justify-center md:justify-start items-center">
          <img
            src={QR}
            alt="QR"
            className="hidden md:block w-[182px] h-[182px] rounded-[12px]"
          />
          <div className="flex flex-col gap-[12px]">
            <a
              href="https://www.rustore.ru/catalog/app/com.sobesednik.ai"
              target="_blank"
              rel="noopener noreferrer"
            >
              <RuStore />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.sobesednik.ai"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GooglePlay />
            </a>
            <a
              href="https://apps.apple.com/us/app/собеседник-ии/id6755813097"
              target="_blank"
              rel="noopener noreferrer"
            >
              <AppStore />
            </a>
          </div>
        </div>

        <div className="hidden absolute right-[38px] -bottom-[112px] md:flex gap-[20px] items-end">
          <img
            src={Login}
            alt="Login"
            className="screen opacity-0 xl:opacity-100 transition-opacity"
          />
          <img
            src={Chat}
            alt="Chat"
            className="screen opacity-0 lg:opacity-100 mb-[207px] transition-opacity"
          />
          <img src={Calendar} alt="Calendar" className="screen mb-[94px]" />
        </div>

        <div className="block md:hidden w-full h-[280px] relative">
          <img
            src={Chat}
            alt="Chat"
            className="screen absolute top-0 left-1/2 -translate-x-[20%] rotate-[5.29deg]"
          />
          <img
            src={Login}
            alt="Login"
            className="screen absolute top-[50px] left-1/2 -translate-x-[80%] -rotate-[4.87deg]"
          />
        </div>
      </div>
    </section>
  );
}
